import { DatepickerOverrides } from 'baseui/datepicker'
import { styled } from 'parkdepot-shared/theme'

export const Title = styled('h6', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.LabelLarge,
    fontWeight: 700
}))

export const DurationIcon = styled('i', () => ({
    fontSize: '1.6rem'
}))

export const DurationWarning = styled('p', ({ $theme }) => ({
    margin: '1.2rem 0 0 0',
    ...$theme.typography.LabelXSmall,
    fontWeight: 700,
    color: $theme.colors.primary,
    padding: '1.6rem 2.4rem',
    backgroundColor: '#F7F7FF',
    borderRadius: '1.6rem',
    display: 'flex',
    gap: '1.2rem',
    alignItems: 'center'
}))

export const DatePickerOverrides: DatepickerOverrides = {
    Popover: {
        props: {
            overrides: {
                Body: {
                    style: {
                        zIndex: 11,
                        borderRadius: '2.4rem',
                        overflow: 'hidden',
                        width: 'fit-content',
                        maxWidth: '90vw' // Prevent overflow on narrow screens
                    }
                },
                Inner: {
                    style: {
                        borderRadius: '2.4rem'
                    }
                }
            }
        }
    },
    Input: {
        props: {
            readOnly: true,
            overrides: {
                InputContainer: {
                    style: () => ({
                        height: '5rem',
                        backgroundColor: '#fff'
                    })
                },
                Input: {
                    style: () => ({
                        borderRadius: '2.4rem !important'
                    })
                }
            }
        }
    },
    InputLabel: {
        style: ({ $theme }) => ({
            ...$theme.typography.ParagraphSmall
        })
    },
    Root: {
        style: () => ({
            backgroundColor: '#fff'
            // display: 'contents'
        })
    },
    CalendarContainer: {
        style: ({ $theme }) => ({
            ...$theme.typography.ParagraphSmall,
            backgroundColor: '#fff',
            borderBottomLeftRadius: '2.4rem',
            borderBottomRightRadius: '2.4rem'
        })
    },
    CalendarHeader: {
        style: () => ({
            color: '#ADADAD',
            borderTopLeftRadius: '2.4rem',
            borderTopRightRadius: '2.4rem',
            width: 'auto'
        })
    },
    WeekdayHeader: {
        style: () => ({
            color: '#ADADAD'
        })
    },
    NextButton: {
        style: ({ $theme }) => ({
            color: $theme.colors.primary
        })
    },
    PrevButton: {
        style: ({ $theme }) => ({
            color: $theme.colors.primary
        })
    },
    MonthYearSelectButton: {},
    MonthYearSelectIconContainer: {
        style: () => ({
            display: 'none'
        })
    },
    Day: {
        style: ({ $theme, $selected, $isHighlighted, $pseudoSelected, $disabled, $outsideMonth }) => ({
            ':before': {
                ...(!$outsideMonth && {
                    backgroundColor: '#EFF3FE !important'
                })
            },
            ':after': {
                backgroundColor: '#fff'
            },
            ...(($isHighlighted || $selected) && {
                color: '#fff',
                ':after': {
                    backgroundColor: $theme.colors.primary,
                    color: '#fff',
                    borderTopWidth: '0',
                    borderRightWidth: '0',
                    borderBottomWidth: '0',
                    borderLeftWidth: '0'
                },

                ':before': {
                    backgroundColor: '#eff3fe !important'
                }
            }),
            ...($pseudoSelected && {
                color: $theme.colors.primary,

                ':before': {
                    backgroundColor: '#EFF3FE !important'
                },

                ':hover': {
                    color: '#fff'
                }
            }),
            ...($disabled && {
                color: '#ADADAD !important',
                ':hover': {
                    color: '#ADADAD !important'
                }
            })
        })
    }
}
